import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import LandingPage from './pages/LandingPage'
import AuthorPage from './pages/AuthorPage'
import BlogPage from './pages/BlogPage'
import BlogPostPage from './pages/BlogPostPage'
import ExperimentDetailPage from './pages/ExperimentDetailPage'
import BuildingSiteExperimentPage from './pages/BuildingSiteExperimentPage'
import ToolDetailPage from './pages/ToolDetailPage'
import StatsPage from './pages/StatsPage'
import AdminBlogPage from './pages/AdminBlogPage'
import SocialAnalytics from './components/shared/SocialAnalytics'

function App() {
  return (
    <Router>
      <SocialAnalytics />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/author" element={<AuthorPage />} />
        <Route path="/ryan-deeds" element={<AuthorPage />} />
        <Route path="/notes" element={<BlogPage />} />
        <Route path="/notes/:slug" element={<BlogPostPage />} />
        <Route path="/experiments/building-this-site" element={<BuildingSiteExperimentPage />} />
        <Route path="/experiments/:slug" element={<ExperimentDetailPage />} />
        <Route path="/tools/:toolId" element={<ToolDetailPage />} />
        <Route path="/stats" element={<StatsPage />} />
        <Route path="/admin/blog" element={<AdminBlogPage />} />
        <Route path="/admin/blog/:slug" element={<AdminBlogPage />} />
      </Routes>
    </Router>
  )
}

export default App

